const BASIC = '/v1/ext';

export const GET_PROJECT_API = `${BASIC}/projects`;
export const GET_PROJECT_ITEMS_API = `${BASIC}/project-items`;
export const GET_PROJECT_CHILD_ITEMS_API = `${BASIC}/project-child-items`;
export const GET_FLOORS_API = `${BASIC}/floors`;
export const GET_FACILITIES_API = `${BASIC}/project-item-facilities`;
export const GET_PROJECT_CHILD_ITEMS_FILTERS_API = `${BASIC}/project-child-items/filter-options`;
export const GET_LOCATION_GROUPS_API = `${BASIC}/location-groups`;
export const GET_LOCATION_API = `${BASIC}/locations`;
export const GET_FACILITY_API = `${BASIC}/facilities`;
export const GET_ORGANIZATIONS_DETAIL_API = `${BASIC}/organizations`;
export const USER_CONTACT_API = `${BASIC}/user-contact`;
export const GET_TOUR_API = `${BASIC}/tours`;
export const GET_PAGE_LAYOUT_DATA = `${BASIC}/widget`;
export const GET_TEMPLATE = `/api/widget`;
export const GET_USER_CONTACT_API = `${BASIC}/user-contact/by-child-item`;
export const GET_SHORTEN_LINK = `${BASIC}/shortenlink`;
export const GET_NEWS_API = `${BASIC}/project-news`;
